"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObjectInputStream = void 0;
const ObjectClassMap_1 = require("./ObjectClassMap");
const DataStream_1 = require("./DataStream");
const JavaObjectStream_1 = require("./JavaObjectStream");
class ObjectInputStream {
    constructor(fileOrStream, currentObject, currentClassFields) {
        this.buffer = null;
        if (!(fileOrStream instanceof JavaObjectStream_1.JavaObjectStream)) {
            this.stream = new JavaObjectStream_1.JavaObjectStream(fileOrStream);
            return;
        }
        this.stream = fileOrStream;
        this.currentObject = currentObject;
        this.currentClassFields = currentClassFields;
    }
    readObject() {
        const next = this.stream.next();
        if (next instanceof DataStream_1.DataStream) {
            throw new Error("expected object");
        }
        return next;
    }
    readBoolean() {
        return this.refill().readUint8() !== 0;
    }
    readByte() {
        return this.refill().readUint8();
    }
    readDouble() {
        return this.refill().readFloat64();
    }
    readFloat() {
        return this.refill().readFloat32();
    }
    readInt() {
        return this.refill().readUint32();
    }
    readLong() {
        return this.refill().readUint64();
    }
    readShort() {
        return this.refill().readUint16();
    }
    readFields() {
        if (this.currentClassFields === undefined) {
            throw new Error("not called from readObject method");
        }
        return this.stream.readObjectFields(this.currentClassFields);
    }
    defaultReadObject() {
        if (this.currentObject === undefined) {
            throw new Error("not called from readObject method");
        }
        const values = this.readFields();
        for (const [fieldName, value] of values) {
            if (fieldName in this.currentObject) {
                // @ts-ignore
                this.currentObject[fieldName] = value;
            }
        }
    }
    refill() {
        if (this.buffer && !this.buffer.isEndOfStream()) {
            return this.buffer;
        }
        const next = this.stream.next();
        if (!(next instanceof DataStream_1.DataStream)) {
            throw new Error("expected block data");
        }
        this.buffer = next;
        return this.buffer;
    }
}
exports.ObjectInputStream = ObjectInputStream;
ObjectInputStream.RegisterObjectClass = ObjectClassMap_1.registerObjectClass;
